import fetch from "../fetch";

export default ({ dealCode, id }) =>
  fetch({
    method: "DELETE",
    path: `/clo/deals/${dealCode}/tranche-prices/${id}`
  });
